const getDefaultModalState = () => ({
    currentStep: 0,
    breadcrumbIndex: 0,
    breadcrumbs: [],
    breadCrumbsVisible: false,
    header: null,
});
export default getDefaultModalState;
